class FooterCollapsible extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const toggles = this.querySelectorAll('.footer-collapsible__toggle');
        toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                const content = toggle.nextElementSibling;
                const arrow = toggle.querySelector('.icon-arrow');
                if (content && content.classList.contains('footer-collapsible__content')) {
                    content.style.display = content.style.display === 'none' || !content.style.display ? 'block' : 'none';
                    if (arrow) {
                        arrow.classList.toggle('rotated');
                    }
                }
            });
        });
    }
}
customElements.define('footer-collapsible', FooterCollapsible);